module.exports = __webpack_public_path__ + "img/docks.f0fd5f21.svg";